import {Autocomplete} from '../1elements'
import {useEffect, useState} from 'react'
import {createBusinessCheckList} from '../../services/util/miscellaneousService'
import {removeSelectedOptions} from '../../services/util/formatter'

const autocompleteSx = {
    '& .MuiInputBase-root': {
        padding: 0
    },
    '& .MuiInputBase-input': {
        padding: '5px 13px !important'
    }
}

const ClientSearch = ({selectedClient, setSelectedClient, validation, disabled, selectedClientList}) => {
    const [, setSearchWord] = useState('')
    const [options, setOptions] = useState([])

    const updateSearchWord = (e) => {
        setSearchWord(e.target.value)
    }

    useEffect(()=> {
        createBusinessCheckList()
            .then((checkList)=>{
                setOptions(removeSelectedOptions(checkList, selectedClientList))
            })
    }, [selectedClientList])

    return (
        <Autocomplete sx={autocompleteSx} value={selectedClient} onChangeTextField={updateSearchWord}
                      options={options} onChangeAutocomplete={setSelectedClient} validation={validation}
                      optionLabel={'name'} disabled={disabled} />
    )
}

export default ClientSearch
